import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { FADE_IN } from '../../util/animations/animation';
import { messages } from '../../util/tooltip-messages';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../../services/http/http.service';
import { LoaderService } from '../../services/loader/loader.service';
import { MovePatientPopupComponent } from '../move-patient-popup/move-patient-popup.component';
import { CommunicationService } from '../../services/communication/communication.service';
import { ConfirmPopupComponent } from '../../shared/popups/confirm-popup/confirm-popup.component';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import * as _ from 'underscore';
import * as $ from 'jquery';
import { TaskDetailPopupComponent } from '../task-detail-popup/task-detail-popup.component';
import { LabelComponent } from '../../shared/component/label/label.component';
import { HelperService } from '../../util/helper/helper.service';
import { ArchivePatientPopupComponent } from '../archive-patient-popup/archive-patient-popup.component';
import * as moment from 'moment';
import { notification } from '../../util/notification-config';
import { MessageContainerComponent } from '../../shared/component/message-container/message-container.component';
import { FirebaseMiddlewareService } from '../../services/firebase-middleware/firebase-middleware.service';
import { QueueFilterComponent } from '../queue-filter/queue-filter.component';
import { Auth0Service } from '../../authentication/auth0/auth0.service';
import { environment } from '../../../environments/environment';

let interval;
/**
 * This component is used to manage the dashboard functionality, it has the following functionality
 *
 * 1. Add queue
 * 
 * 2. Search patient
 * 
 * 3. Move task from one queue to another
 * 
 * 4. Archive task
 * 
 * 5. Change queue position
 */
@Component({
  selector: 'app-ticket-board',
  templateUrl: './ticket-board.component.html',
  styleUrls: ['./ticket-board.component.scss'],
  animations: [FADE_IN]
})

export class TicketBoardComponent implements OnInit {
  isAddQueue = false;
  tooltip = messages.dashboard;
  queueForm: FormGroup;
  allQueues = [];
  orderingQueue = [];
  positionQueue = [];
  fireAuthListener;
  queueListener;
  labelListener;
  communicationListener;
  boards = [];
  selectedBoard: any = {};
  selectedBoardName = '';
  subscribers = [];
  isExpandLabel = false;
  labels = [];
  communicationMessages = [];
  notificationSettings: any = {};
  allCommunications = [];
  isComponentDistroy = false;
  shouldUnsubscribe = true;
  filters;
  timeout;
  queueFilters = [];
  userId;
  /**
  * @ignore
  */
  fakeTasks = [
    { id: 1 },
    { id: 2 },
    { id: 3 },
    { id: 4 },
    { id: 5 }
  ]

  constructor(private FB: FormBuilder,
    private httpService: HttpService,
    private loader: LoaderService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private router: Router,
    private afs: AngularFirestore,
    public auth: AngularFireAuth,
    private helper: HelperService,
    private firebaseMiddlewareService: FirebaseMiddlewareService,
    private communicationService: CommunicationService,
    private auth0: Auth0Service) {
    let url = this.router.url;
    url = url.split('/').pop();
    this.selectedBoardName = url.split('?')[0];
    /**
    * get search payload to call the search API  
    * 
    * If isSearch is start then call the search patient API, isSearch is stop then reset the dashboard data
    */
    // let sub = this.communicationService.searchPatient.subscribe(payload => {
    //   if (payload.isSearch === 'start') {
    //     if (payload.searchText) {
    //       setTimeout(x => {
    //         this.searchPatient(payload);
    //       }, 100)
    //     }
    //   } else if (payload.isSearch === 'stop')
    //     this.getQueues(true);
    // })
    // this.subscribers.push(sub);
    /**
    * get boards from communication service to display this in move patient popup  
    */
    let sub = this.communicationService.getBoards.subscribe(boards => {
      this.boards = boards;
      this.selectedBoard = this.boards.find(x => x.routeName === this.selectedBoardName);
    })
    this.subscribers.push(sub);

    /**
    * get labels from communication service to bind this labels in popup
    */
    sub = this.communicationService.getLabels.subscribe(labels => {
      this.labels = _.object(_.map(labels, (item: any) => [item.id, item]));
    })
    this.subscribers.push(sub);

    document.addEventListener("visibilitychange", () => {
      if (document.hidden && !this.isComponentDistroy) {
        this.shouldUnsubscribe = true;
        this.timeout = setTimeout(x => {
          if (this.shouldUnsubscribe) {
            console.log("hidden")
            this.unSubscribeListener(this.allQueues, 'taskListener');
            this.unSubscribeListener(this.queueListener);
            this.shouldUnsubscribe = false;
          }
        }, 120000)
      } else if (!this.isComponentDistroy) {
        if (!this.shouldUnsubscribe) {
          console.log("visible")
          this.getQueues(true);
        }
        clearTimeout(this.timeout);
        this.shouldUnsubscribe = false;
      }
    }, false);

    sub = this.communicationService.getTaskFilter.subscribe(res => {
      this.filters = res;
    })
    this.subscribers.push(sub);

    sub = this.communicationService.allCommunications.subscribe(res => {
      this.allCommunications = res;
      if (this.allQueues.length) {
        this.allQueues.map(x => {
          this.formatTasks(x.id, x.tasks);
        })
      }
    })
    this.subscribers.push(sub);

    sub = this.communicationService.getDashCommunications.subscribe(res => {
      this.communicationMessages = res.filter(x => {
        x.data = x.data.filter(y => y.type !== 'removed');
        return x.data.length;
      });
      if (this.communicationMessages.length && this.communicationMessages[0].data.length) {
        const endTime = moment();
        const startTime = moment(this.communicationMessages[0].data[0].sent);
        const duration = moment.duration(endTime.diff(startTime));
        const min = duration.asMinutes();
        const notify = notification.find(x => this.helper.condtion(x.conditions, min))
        this.notificationSettings = notify && notify.settings || {};
      } else {
        this.notificationSettings = {};
      }
    })
    this.subscribers.push(sub);

    this.userId = this.auth0.idTokenDetail[`${environment.auth0Config.audience}practitioner_id`];
  }

  ngOnInit() {
    this.getLabels();
    this.getQueueFilters();
    if (this.selectedBoard && this.selectedBoard.id)
      this.getQueues(false);
    this.generateQueueForm();
    interval = setInterval(() => { console.log() }, 60000)
  }

  generateQueueForm() {
    this.queueForm = this.FB.group({
      queueName: ['', [Validators.required]],
      queueDescription: ['', [Validators.required]]
    })
  }

  drop(event: CdkDragDrop<any>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
      const payload = {
        taskId: event.container.data[event.currentIndex].id,
        resultQueue: event.container.id
      }
      this.APICall(`task/changeQueue/${payload.taskId}`, payload, payload.resultQueue);
    }
  }

  autoMoveCard(task, queue) {
    const dialogRef = this.dialog.open(MovePatientPopupComponent, {
      width: '450px',
      panelClass: 'custom-dialog-container',
      data: {
        title: 'Move Patient',
        subTitle: 'Select the queue to move the patient',
        queueName: queue.queueName,
        queueId: queue.id,
        task,
        selectedBoard: this.selectedBoard
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res && res.data) {
        const payload = {
          taskId: task.id,
          resultQueue: res.data.queueId,
          moveLabel: res.data.moveLabel
        }
        this.APICall(`task/changeQueue/${task.id}`, payload, payload.resultQueue);
      }
    });
  }

  /**
  * To auto-scroll right after adding the new queue to the dashboard
  * 
  * To create a new queue into the particular dashboard, need to provide queue name and description. On click of “add dashboard” system calls backend API (FHIR health). Once it added into the FHIR health it will update the data on firebase. The firebase triggers the updated data to frontend.
  */
  enableAddQueue() {
    this.isAddQueue = !this.isAddQueue;
    if (this.isAddQueue) {
      setTimeout(x => {
        $("#page-wrapper").scrollLeft(999999);
      }, 50)
      this.queueForm.reset();
    }
  }

  /**
  * This function is used to add the queues to the dashboard
  */

  addQueue() {
    if (this.queueForm.valid) {
      this.loader.show('progress');
      const payload = this.queueForm.value;
      payload.queueType = 'taskQueue';
      payload.boardId = this.selectedBoard.id;
      this.httpService.post('queue', payload)
        .subscribe((response: any) => {
          this.loader.hide('progress');
          this.enableAddQueue();
          this.toastr.success('added successfully', 'Queue', {
            progressBar: true, timeOut: 3000
          });
        }, error => {
          this.loader.hide('progress');
          this.toastr.warning(error, 'Queue', {
            progressBar: true, timeOut: 3000
          });
        })
    }
  }

  /**
  * common function to call the API 
  */

  APICall(url, payload, queueId) {
    const data = this.allQueues.find(x => queueId && x.id === queueId);
    if (!data || (data && data.status !== 'In-Processing')) {
      this.loader.show('progress');
      this.httpService.post(url, payload)
        .subscribe((response: any) => {
          this.loader.hide('progress');
        }, error => {
          this.loader.hide('progress');
          this.toastr.warning(error, 'Queue', {
            progressBar: true, timeOut: 3000
          });
        })
    } else {
      this.toastr.warning(`Queue is in processing you can't move the tasks`, 'Queue', {
        progressBar: true, timeOut: 3000
      });
    }
  }

  /**
  * To archive a single card from the queue
  * 
  * It helps CareAlly to archive the particular task from the queue, once the task is archived it will not appear in a queue. The patient’s details can still be viewed from the patient list. 
  */

  removeCard(task, queue) {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      width: '450px',
      data: {
        title: { text: 'Alert!' },
        subTitle: { text: `Are you sure, you want to remove?` },
        cancelBtn: { text: 'Cancel' },
        okBtn: { text: 'Confirm' }
      }
    });
    dialogRef.afterClosed().subscribe(action => {
      if (action && action.confirm) {
        this.APICall(`task/archive/${task.id}`, {}, null)
      }
    });
  }

  /**
  * Search patient by name and stop all the firebase subscription
  */
  // searchPatient(payload) {
  //   if (this.selectedBoard) {
  //     this.loader.show('progress');
  //     this.unSubscribeListener(this.allQueues, 'taskListener');
  //     this.unSubscribeListener(this.queueListener);
  //     this.httpService.get(`task/search?taskStatus=requested&${payload.type}=${payload.searchText}&boardId=${this.selectedBoard.id}`)
  //       .subscribe((response: any) => {
  //         this.loader.hide('progress');
  //         this.allQueues.map(x => {
  //           const index = response.findIndex(y => y.id === x.id)
  //           x.tasks = index !== -1 ? this.addLabelToTasks(response[index].tasks) : [];
  //         })
  //       }, error => {
  //         this.loader.hide('progress');
  //         this.toastr.warning(error, 'Queue', {
  //           progressBar: true, timeOut: 3000
  //         });
  //       })
  //   }
  // }

  /**
  * Open patient detail popup on click of patient name
  */
  onPatientNameClick(task) {
    this.dialog.open(TaskDetailPopupComponent, {
      width: '90vw',
      minHeight: '95vh',
      maxHeight: '95vh',
      data: {
        patientId: this.helper.extractId(task.for),
        type: 'popup'
      }
    });
  }

  /**
  * Unsubscribe all the listeners
  */
  ngOnDestroy(): void {
    this.isComponentDistroy = true;
    // this.communicationService.setCommunicationData([]);
    // this.unSubscribeListener(this.communicationListener);
    this.communicationService.resetDashboardCommunciation();
    this.communicationService.onSearch({})
    this.subscribers.map(x => x.unsubscribe());
    this.unSubscribeListener(this.allQueues, 'taskListener');
    this.unSubscribeListener(this.queueListener);
    this.unSubscribeListener(this.labelListener);
    this.communicationService.setTaskFilter({ labels: [], searchText: '' })
    clearInterval(interval);
    ($('.card-search')).hide(200);
  }

  /**
  * To remove the particular queue from the dashboard, it asks for confirmation
  */
  removeQueue(queue) {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      width: '450px',
      data: {
        title: { text: 'Alert!' },
        subTitle: { text: `Are you sure, you want to archive "${queue.queueName}"?` },
        cancelBtn: { text: 'No' },
        okBtn: { text: 'Yes' }
      }
    });
    dialogRef.afterClosed().subscribe(action => {
      if (action && action.confirm) {
        if (queue.tasks.length) {
          this.dialog.open(ConfirmPopupComponent, {
            width: '450px',
            data: {
              title: { text: 'Warning!' },
              subTitle: { text: `Please make sure the queue is empty before archiving it` },
              okBtn: { text: 'Ok' }
            }
          });
        } else {
          this.deleteQueue(queue);
        }
      }
    });
  }

  /**
  * To remove the queue from the dashboard
  */
  deleteQueue(queue) {
    const payload = {
      queueId: queue.id,
      boardId: this.selectedBoard.id
    }
    this.APICall(`queue/archive`, payload, payload.queueId)
  }

  /**
  * get all active and in-processing queues from firebase
  * 
  * Before getting the queue, check it firebase authentication
  * 
  * Order the queues based on next properties(link list logic)
  */
  getQueues(isRefresh) {
    if (this.selectedBoard) {
      this.loader.show('progress');
      this.fireAuthListener = this.auth.authState.subscribe(isAuthenticated => {
        if (isAuthenticated) {
          this.fireAuthListener.unsubscribe();
          this.queueListener = this.afs.collection("Queue", ref => ref.where("board.reference", '==', `QueueBoard/${this.selectedBoard.id}`)).valueChanges().subscribe((queues: any) => {
            queues = queues.filter(x => x.status === 'Active' || x.status === 'In-Processing')
            // Apply filter
            queues.map(x=>{
              x.hidden = this.queueFilters.findIndex(y=> y ===x.id) !== -1;
            })
            this.orderingQueue = this.helper.orderQueue(queues); // Call link list logic
            if (this.orderingQueue.length) {
              this.allQueues.map(x => { // unsubscribe all the queues which are in In-Processing
                const temp = queues.find(y => y.id === x.id && y.status === 'In-Processing');
                if (temp && x.taskListener)
                  x.taskListener.unsubscribe()
              })
              this.positionQueue = [];
              this.orderingQueue.map((x, i) => {
                x.className = `.queue${i}`;
                this.positionQueue.push(x.id);
                if (x.status === 'Active'&&!x.hidden)// if queue status is active then call get tasks function
                  this.getTasks(x);
              })
              this.bindQueues(isRefresh);
              // this.allQueues = this.orderingQueue;
            }
            this.loader.hide('progress');
          });
        }
      })
    }
  }

  /**
  * Whether to refresh all queues in UI, or only a particular queue
  */

  bindQueues(isRefresh) {
    if (this.orderingQueue.length === this.allQueues.length && !isRefresh) {
      this.orderingQueue.map((x, i) => {
        if (x.id === this.allQueues[i].id) {
          if (x.status !== this.allQueues[i].status)
            this.allQueues[i] = x;
        } else
          this.allQueues = this.orderingQueue;
      })
    } else
      this.allQueues = this.orderingQueue;
  }

  /**
  * get all active tasks based on queue id
  */
  getTasks(queue) {
    queue.taskListener = this.afs.collection("Task", ref => ref.where("basedOn", "array-contains", { reference: `Basic/${queue.id}` }).where("status", '==', 'requested').orderBy('effectiveDate')).valueChanges().subscribe(tasks => {
      if (queue.status === 'Active') {
        queue.tasks = this.formatTasks(queue.id, tasks);
        // this.getCommunications()
      }
    })
  }

  formatTasks(queueId, tasks) {
    let communications = [];
    tasks && tasks.map((x: any) => {
      this.assignLable(x);
      communications = [...communications, ...this.filterCommunications(this.allCommunications, queueId, x)];
    })
    this.communicationService.setDashboardCommunciation({ queueId, communications });
    return tasks;
  }

  assignLable(item) {
    item.labelObjects = [];
    if (item.label) {
      item.label.map(y => {
        if (this.labels[this.helper.extractId(y)])
          item.labelObjects.push(this.labels[this.helper.extractId(y)]);
      })
    }
  }

  filterCommunications(communications, queueId, item) {
    return communications.filter(y => {
      if (y.id === this.helper.extractId(item.for)) {
        y.queueId = this.helper.extractId(item.basedOn[0]);
        return true;
      } else
        return false;
    })
  }

  /**
  * Change the position of the queue
  */

  changePosition(queue, oldPostition, newPosition) {
    const newData = [...this.positionQueue];
    const removeQueue = newData.splice(oldPostition, 1);
    newData.splice(newPosition, 0, removeQueue[0]);
    const payload = {
      queueId: queue.id,
      prevQueueId: newData[newPosition - 1] || 'NULL',
      boardId: this.selectedBoard.id
    }
    this.APICall(`queue/move`, payload, payload.queueId)
  }

  /**
  * common function to unsubscribe listeners
  * 
  * it identifies the array or object and unsubscribes it
  */
  unSubscribeListener(data, key?) {
    if (_.isArray(data)) {
      data.map(x => {
        if (x[key])
          x[key].unsubscribe()
      })
    } else if (data)
      data.unsubscribe();
  }

  /**
  * Apply label to the tasks using the popup
  */

  openLablePopup(task): void {
    const dialogRef = this.dialog.open(LabelComponent, {
      width: '400px',
      maxHeight: '95vh',
      panelClass: 'custom-dialog-container',
      disableClose: true,
      data: {
        queueBoardId: this.selectedBoard.id,
        task
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  /**
  * Expand or Collapse the applied label on tasks
  */
  onExpandCollaps() {
    this.isExpandLabel = !this.isExpandLabel;
  }

  /**
  * Get all active lables
  */
  getLabels() {
    if (this.selectedBoard) {
      this.labelListener = this.afs.collection("Label", ref => ref.where("status", '==', 'Active').where("queueBoard.reference", '==', `QueueBoard/${this.selectedBoard.id}`)).valueChanges().subscribe(labels => {
        this.communicationService.setLabels(labels);
        this.allQueues.map(x => {
          x.tasks = this.formatTasks(x.id, x.tasks);
        })
      })
    }
  }

  /**
  * Bind labels to tasks based on id
  */
  addLabelToTasks(tasks) {
    tasks && tasks.map((x: any) => {
      x.labelObjects = [];
      if (x.label)
        x.label.map(y => {
          if (this.labels[this.helper.extractId(y)])
            x.labelObjects.push(this.labels[this.helper.extractId(y)]);
        })
    })
    return tasks;
  }

  /**
  * To increase the performance of ngFor
  */
  trackByMethod(index: number, el: any): number {
    return el.id;
  }

  /**
  * Move all cards from one queue to another 
  * 
  * Disable the processing queue while moving the cards
  */
  moveAllCards(queue) {
    const dialogRef = this.dialog.open(MovePatientPopupComponent, {
      width: '450px',
      panelClass: 'custom-dialog-container',
      data: {
        title: 'Move All Patients',
        subTitle: 'Select the queue to move the patients',
        queueName: queue.queueName,
        queueId: queue.id,
        selectedBoard: this.selectedBoard
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res && res.data) {
        const payload = {
          sourceQueueId: queue.id,
          resultQueueId: res.data.queueId,
          moveLabel: res.data.moveLabel
        }
        this.APICall('task/changeQueue', payload, payload.resultQueueId);
      }
    });
  }

  /**
  * Archive all cards from a queue
  * 
  * Disable the processing queue while archiving the cards
  */
  archiveAllCards(queue) {
    const dialogRef = this.dialog.open(ArchivePatientPopupComponent, {
      width: '450px',
      data: {
        title: 'Archive cards',
        queueName: queue.queueName,
        queueId: queue.id,
        selectedBoard: this.selectedBoard
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res && res.data) {
        const payload = res.data;
        const date = this.helper.setZeroTime(payload.date);
        payload.date = this.helper.isoFormat(date);
        this.APICall('task/archive', payload, payload.queueId)
      }
    });
  }

  getDisplayDate(date) {
    return moment(date).fromNow();
  }

  openMessages() {
    if (this.communicationMessages.length) {
      const dialogRef = this.dialog.open(MessageContainerComponent, {
        width: '80vw',
        height: '90vh',
        panelClass: 'custom-dialog-container',
        data: {}
      });
      dialogRef.afterClosed().subscribe(res => {
        // if (this.communicationListener)
        //   this.communicationListener.unsubscribe();
        // this.getCommunications();
      })
    }
  }
  
  getQueueFilters(){
    const allFilters = JSON.parse(localStorage.getItem('queue-filters'));
    const filtersOfUser = allFilters&&allFilters[this.userId];
    this.queueFilters = filtersOfUser && filtersOfUser[this.selectedBoard.id] || [];
      this.loader.show();
      this.orderingQueue.map(x=> {
        const index = this.queueFilters.findIndex(y=> y === x.id);
        if(index !== -1){
          if(x.taskListener){
            x.taskListener.unsubscribe();
            x.taskListener = null;
          }
          x.tasks = [];
        }else if(!x.taskListener){
          this.getTasks(x);
        }
      })
      this.loader.hide();
  }

  openQueueFilter() {
    if (this.allQueues.length) {
      const dialogRef = this.dialog.open(QueueFilterComponent, {
        width: '30vw',
        disableClose: true,
        data: {
          board: this.selectedBoard,
          queues: this.allQueues
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.getQueueFilters();
      });
    }
  }
}
